import useSWR from 'swr'
import API from '../../../utils/api'
import { ADMIN_GROUP } from '../../constants/APIKEYS'
import { useToken } from '../auth/token'
import { message } from 'antd'

let KEY = ADMIN_GROUP

let swrData: any = null
let updateData: any = null
export function useGroupFee() {
	const { data: token } = useToken()

	const { data, mutate } = useSWR<any>(
		`${KEY}`,
		async () => {
			if (updateData || !swrData) {
				const response = await API.get(KEY, token + '', {})
				swrData = response.result.result
				updateData = null
				console.log('Table API', response)
				return swrData
			} else {
				console.log('Table API2', swrData)
				return swrData
			}
		},
		{
			revalidateOnMount: true,
			revalidateOnFocus: true,
		}
	)

	return {
		data,
		mutate: async (value?: any) => {
			if (value !== undefined) {
				updateData = value
			}
			return mutate()
		},
		addGroupFee: async (value?: any) => {
			API.post('/admin/group', token + '', value).then(res => {
				console.log(res)
				updateData = true

				mutate()
			})
		},
		deleteGroupFee: async (value?: any) => {
			API.delete('/admin/group/' + value, token + '', {}).then(res => {
				console.log(res)
				updateData = true

				message.info('성공적으로 삭제되었습니다')
				mutate()
			})
		},
	}
}
